'use client';

import type { ReactNode } from 'react';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

export function IdentityStreamBoundary({ children }: { children: ReactNode }) {
  return <RpErrorBoundary fallback={null}>{children}</RpErrorBoundary>;
}
